import { useEffect, useRef, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import {
  useMarkStoryAsListenedMutation,
  useUpdateTimeStoppedMutation,
} from 'graphql/generated/graphql';

import useGraphaelDefaults from 'hooks/useGraphaelDefaults';

import { addAlreadyListenedStory } from 'store/modules/userAlreadyListenedStories';
import ReduxState from 'store/ReduxState';

export const useStoryListen = (storyId: string) => {
  const dispatch = useDispatch();
  const [markedAsListened, setMarkedAsListened] = useState(false);
  const lastKnownDurationRef = useRef<number>();
  const lastKnownStoryIdRef = useRef<string>();

  const currentTime = useSelector<ReduxState, number>(
    ({ player }) => player.currentTime,
  );
  const currentlyPlayingStoryId = useSelector<ReduxState, string | undefined>(
    ({ player }) => player.currentlyPlaying?.id,
  );

  const [markStoryAsListened] = useMarkStoryAsListenedMutation(
    useGraphaelDefaults(),
  );

  const [updateTimeStopped] = useUpdateTimeStoppedMutation(
    useGraphaelDefaults(),
  );

  useEffect(() => {
    setMarkedAsListened(false);
    lastKnownDurationRef.current = 0;
    lastKnownStoryIdRef.current = String(currentlyPlayingStoryId);
  }, [currentlyPlayingStoryId]);

  useEffect(() => {
    if (currentTime > 0) {
      lastKnownDurationRef.current = currentTime;
      lastKnownStoryIdRef.current = String(currentlyPlayingStoryId);
    }
  }, [currentTime, currentlyPlayingStoryId]);

  useEffect(() => {
    if (
      storyId === lastKnownStoryIdRef.current &&
      currentTime >= 60 &&
      !markedAsListened
    ) {
      setMarkedAsListened(true);
      markStoryAsListened({
        variables: {
          storyId: storyId,
          timeStopped: currentTime,
        },
      });

      dispatch(addAlreadyListenedStory(storyId));
    }
  }, [
    currentTime,
    currentlyPlayingStoryId,
    dispatch,
    markStoryAsListened,
    markedAsListened,
    storyId,
  ]);

  useEffect(() => {
    return () => {
      if (
        storyId === lastKnownStoryIdRef.current &&
        lastKnownDurationRef.current &&
        lastKnownDurationRef.current >= 60
      ) {
        updateTimeStopped({
          variables: {
            storyId: storyId,
            timeStopped: lastKnownDurationRef.current,
          },
        });
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storyId]);
};
